import styled from 'styled-components';

interface ContainerProps {
  progress: number;
  color: string;
}

export const Container = styled.div<ContainerProps>`
  background-color: ${({ theme }) => theme.colors.lightGrey};
  height: 5px;
  width: 100%;
  border-radius: 2.5px;

  div {
    background-color: ${({ color }) => color};
    height: 5px;
    width: ${({ progress }) => progress}%;
    border-radius: 2.5px;
  }
`;
